import React, { useMemo } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { ROTAS_ACCESS_ROLES } from '../../constants/roles';
import { ROUTES } from '../../routes';
import RouteDetailPage from './RouteDetailPage';
import RoutePlanningPage from './RoutePlanningPage';
import RoutesListPage from './RoutesListPage';

export default function Rotas() {
    const { user } = useAuth();
    const userRoles = user?.roles;

    const canAccessRotas = useMemo(
        () => (userRoles || []).some((role) => ROTAS_ACCESS_ROLES.includes(role)),
        [userRoles]
    );

    if (!canAccessRotas) {
        return <Navigate to={ROUTES.DASHBOARD} replace />;
    }

    return (
        <Routes>
            <Route index element={<RoutesListPage />} />
            <Route path="nova" element={<RoutePlanningPage />} />
            <Route path=":id" element={<RouteDetailPage />} />
            <Route path="*" element={<Navigate to={ROUTES.ROTAS} replace />} />
        </Routes>
    );
}
